module.exports = __webpack_public_path__ + "static/media/desktop_illustration_side2_side3_xmas.c5bb1600.png";